import Api from "../../axios";

export default async function deleteAttendanceRequest(id) {
  return await Api.delete(`/delete_attendance/${id}`);
}
